const getters = {
  dialogFullscreen: (state) => state.app.dialogFullscreen,
  labelPosition: state => state.app.labelPosition,
  device: state => state.app.device,
};
export default getters;
